import {
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  AFFILIATE_DISCLOSURE,
  COMPANY_EMAIL,
  COMPANY_NAME,
  FOOTER_DISCLAIMER,
  SITE_NAME,
} from './site';

export const COPYRIGHT_END = new Date().getFullYear();

export const CRUISE_LEGAL_DISCLAIMER = [
  ...FOOTER_DISCLAIMER,
  'Cruise fares, cabin categories, and sailing availability shown on this site are sample quotes for comparison purposes. Final pricing is confirmed by the cruise line or supplier at the time of booking and may change without notice.',
  'Service fees, post-booking fees, cancellation terms, and refund eligibility vary by sailing, fare type, and supplier policy. Contact our cruise team before confirming payment for a full breakdown of applicable charges.',
  'Fast Fares cruise search results display representative sailings from a sample catalog. Live inventory, cabin assignments, and promotional fares are subject to supplier confirmation.',
];

export const CRUISE_FOOTER_POLICIES = [
  { href: 'https://travelnodex.online/service-fees', label: 'Service Fees' },
  { href: 'https://travelnodex.online/post-ticketing-fees', label: 'Post Booking Fees' },
  { href: 'https://travelnodex.online/cancellation-refund', label: 'Cancellation & Refund' },
  { href: 'https://travelnodex.online/price-match', label: 'Price Match Promise' },
  { href: 'https://travelnodex.online/fulfillment-policy', label: 'Fulfillment Policy' },
  { href: 'https://travelnodex.online/advertiser-disclosure', label: 'Advertiser Disclosure' },
];

export const CRUISE_FOOTER_COMPANY = [
  { href: 'https://travelnodex.online/about', label: 'About Us' },
  { href: 'https://travelnodex.online/privacy', label: 'Privacy Policy' },
  { href: 'https://travelnodex.online/cookies', label: 'Cookie Policy' },
  { href: 'https://travelnodex.online/terms', label: 'Terms & Conditions' },
  { href: 'https://travelnodex.online/fare-disclosure', label: 'Fare Disclosure' },
];

export const CRUISE_FOOTER_SUPPORT = [
  { href: '#enquiry', label: 'Contact Us' },
  { href: `mailto:${COMPANY_EMAIL}`, label: 'Email Support' },
  { href: '/', label: 'Car Rentals Home' },
];

/** Top header bar — shown centered on mobile */
export const CRUISE_HEADER_DISCLAIMER_SHORT = AFFILIATE_DISCLOSURE;

export const CRUISE_FOOTER_META = {
  affiliate: AFFILIATE_DISCLOSURE,
  companyLine: `${COMPANY_NAME} · ${ADDRESS_LINE1}, ${ADDRESS_LINE2}`,
  operator: `${SITE_NAME} cruise bookings are operated by ${COMPANY_NAME}, an independent travel advisory company affiliated with Fora Travel.`,
};
